<template>
    <div class="engine">
        <div class="label">{{ $t('common.modals.create_external.engines.ms-qna.msQnaSettings') }}</div>

        <div class="engine--description">
          {{ $t('common.modals.create_external.engines.ms-qna.readMoreAbout') }}
          <a class="engine--info-url" :href="msQnaUrl" target="_blank">
            {{ $t('common.modals.create_external.engines.ms-qna.here') }}
          </a>
        </div>

        <or-textbox
            v-model="localMsQnaModel.settings.region"
            :label="$t('common.modals.create_external.engines.ms-qna.resourceName')"
            :placeholder="$t('common.modals.create_external.engines.ms-qna.enterResourceName')"
        />

        <or-textbox
            v-model="localMsQnaModel.settings.modelId"
            :label="$t('common.modals.create_external.engines.ms-qna.qnaModelId')"
            :placeholder="$t('common.modals.create_external.engines.ms-qna.enterQnaModelId')"
        />

        <or-textbox
            v-model="localMsQnaModel.settings.authorizationKey"
            :label="$t('common.modals.create_external.engines.ms-qna.resourceApiEndpointKey')"
            :placeholder="$t('common.modals.create_external.engines.ms-qna.enterEndpointKey')"
        />

        <or-code
            v-model="localMsQnaModel.settings.bodyTemplate"
            :label="$t('common.modals.create_external.engines.ms-qna.customRequestBody')"
            :full-screen="false"
            mode="json"
            helpText="With this field you can add some custom fields to the request body"
        />
    </div>
</template>

<script>
import { MS_QNA_DOCS_URL } from '@/config'

export const getDefaultMsQnaSettings = () => ({
  modelId: '',
  region: '',
  authorizationKey: '',
  bodyTemplate: JSON.stringify({})
})

export default {
  props: {
    msQnaModel: {
      settings: {
        region: String,
        modelId: String,
        authorizationKey: String,
        bodyTemplate: String
      }
    },
    errors: {
      settings: {}
    }
  },

  computed: {
    localMsQnaModel: {
      get () {
        return this.$props.msQnaModel
      },
      set (value) {
        this.$emit('update:msQnaModel', value)
      }
    }
  },

  data () {
    return {
      msQnaUrl: MS_QNA_DOCS_URL
    }
  }
}
</script>

<style scoped>

</style>
